import angular from 'angular';
import ProductPartsService from './parts.service';
import ProductPartsDataProvider from './parts.dataprovider.service';

export default angular.module('product-parts', [])
  .service('ProductPartsService', ProductPartsService)
  .service('ProductPartsDataProvider', ProductPartsDataProvider)
  .name;


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-parts/index.js
 **/